import { Component } from '@angular/core';
import { AlarmTableRowComponent } from '@components/alarm-table-row/alarm-table-row.component';

@Component({
    selector: 'app-alarm-table-row-wrap',
    templateUrl: './alarm-table-row-wrap.component.html',
    styleUrls: ['./alarm-table-row-wrap.component.scss'],
    standalone: false
})
export class AlarmTableRowWrapComponent extends AlarmTableRowComponent {}
